import React, { useContext } from 'react'

import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import FormField from 'components/FormField'
import SoftButton from 'components/SoftButton'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'
import { IntakeContext } from 'context/IntakeContext'
import Slide from '@mui/material/Slide'
import { toast } from 'react-toastify'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const UpdateFieldModalForm = ({
  handleClose,
  open,
  handleSubmit,
  title,
  userField,
}) => {
  const { reloadUser, intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const onSubmit = async () => {
    updateUser()
    toast.info(
      `You have successfully updated your ${
        userField === 'tspBalance' ? 'Traditional TSP' : 'Roth TSP'
      } details`,
      {
        position: 'top-center',
        autoClose: 5000,
        pauseOnFocusLoss: false,
        pauseOnHover: false,
      }
    )
    reloadUser()
    handleSubmit()
  }

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>Update {title}</DialogTitle>
      <DialogContent>
        <Grid item xs={12}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <SoftBox
                display="flex"
                flexDirection="column"
                justifyContent="flex-end"
                height="100%"
              >
                {renderMuiFormField({
                  id: userField,
                  label: '',
                  placeholder: '$250,000',
                  inputType: 'currencyFloat',
                  value: intakeState[userField],
                  onChange: (updatedBalance) =>
                    userField === 'tspBalance'
                      ? updateIntakeStateAtKey({ tspBalance: updatedBalance })
                      : updateIntakeStateAtKey({
                          tspRothBalance: updatedBalance,
                        }),
                })}
              </SoftBox>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <SoftButton variant="text" color="dark" onClick={handleClose}>
          Cancel
        </SoftButton>
        <SoftButton
          variant="gradient"
          color="dark"
          sx={{ height: '100%' }}
          onClick={onSubmit}
        >
          Save
        </SoftButton>
      </DialogActions>
    </Dialog>
  )
}
